<script lang="ts">
  import { Alert, NewEntityView } from '$shared/components';
  import type { AlertDetailedInfo } from '$provider/models/AlertDetailedInfo';
  import type { EntityViewType } from '$shared/components/types';
  import { AlertOption } from '$shared/models/AlertOption';

  interface Props {
    options: EntityViewType;
    verifiedOn: string;
    alert?: AlertDetailedInfo | string;
    onevent?: (payload: any) => void;
  }

  let { options, verifiedOn, alert = '', onevent }: Props = $props();
</script>

<div class="review-comp">
  <div class="alert">
    <div class="text">
      Some items do not match your provided information.<br /> Please review and update this record.
    </div>
    <div class="date">{verifiedOn || ''}</div>
  </div>
  {#if alert}
    <div class="warn-alert">
      <Alert maxWidth data={alert} options={AlertOption.warnAlert()} />
    </div>
  {/if}
  <NewEntityView {options} {onevent} />
</div>

<style>
  .alert {
    background-color: #ffffff;
    border: 1px solid #0d54f5;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 16px;
    margin-bottom: 32px;
  }
  .alert .text {
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    color: var(--blue);
  }
  .alert .date {
    font-weight: normal;
    font-size: 12px;
    line-height: 23px;
    color: var(--grey-medium);
    margin-left: 16px;
  }
  .warn-alert {
    margin-bottom: 22px;
  }
</style>
